const useAuth = () => {
  return {
    userId: localStorage.getItem('userId') || '',
    email: localStorage.getItem('email') || '',
    userName: localStorage.getItem('userName') || '',
  };
};

export const useIsSelf = (userId: string): boolean => {
  const signedInUserId = useAuth().userId;
  return signedInUserId !== '' && signedInUserId === userId;
};

export default useAuth;
